import React, { useEffect, useReducer } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import dayjs from "dayjs";

// Custom.
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import VoTextField from "@vocollege/components/dist/VoTextField";
import VoDatePickerField from "@vocollege/components/dist/VoPickerField/VoDatePickerField";
import { getInitialState } from "./state";
import { reducer } from "@vocollege/app/dist/modules/VoHelpers";
import { HeaderProps } from "../../global";
import VoSelectField from "@vocollege/components/dist/VoSelectField";
import { GeneralObject } from "@vocollege/app";
import DownloadCsvButton from "components/DownloadCsvButton";
import DownloadExcelButton from "@vocollege/components/dist/DownloadExcelButton";

const Header: React.FC<HeaderProps> = (props) => {
  const {
    filters = [],
    groupBy = ["educator", "local", "region"],
    onChange,
    csv,
    excel,
  } = props;
  const [state, dispatch] = useReducer(reducer, getInitialState());

  const handleChange = (field: string, newValue: unknown) => {
    dispatch({ key: field, values: newValue });
  };

  const getFilename = (data: any, format?: string) => {
    const name: string[] = [];
    name.push(data?.filename || format);
    if (state.from) {
      name.push(state.from);
    }
    if (state.to) {
      name.push(state.from);
    }
    if (state.groupBy) {
      let groupByItem = I18n.get.vocertStatistics.groupByValues.diplomas.find(
        (v: GeneralObject) => v.value === state.groupBy
      );
      if (groupByItem) {
        name.push(groupByItem.label.toLowerCase().replace(" ", "_"));
      }
    }
    return name.join("_");
  };

  // Effects.

  useEffect(() => {
    dispatch({
      values: {
        from: dayjs().subtract(1, "months").format("YYYY-MM-DD"),
        to: dayjs().format("YYYY-MM-DD"),
        // from: dayjs("2026-01-20").format("YYYY-MM-DD"),
        // to: dayjs("2026-01-20").format("YYYY-MM-DD"),
        groupBy: groupBy[0],
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      sx={{
        "@media print": {
          display: "none",
        },
      }}>
      <Grid container spacing={2}>
        {filters.indexOf("from") > -1 && (
          <Grid item xs={12} md={3} alignItems="center">
            <VoDatePickerField
              label={I18n.get.misc.from}
              inputFormat="YYYY-MM-DD"
              value={state.from}
              onChange={(newValue: any) =>
                handleChange("from", newValue.format("YYYY-MM-DD"))
              }
              renderInput={(params: any) => (
                <VoTextField
                  {...params}
                  label={I18n.get.misc.from}
                  variant="filled"
                  fullWidth
                  required
                  size="small"
                />
              )}
            />
          </Grid>
        )}
        {filters.indexOf("to") > -1 && (
          <Grid item xs={12} md={3}>
            <VoDatePickerField
              label={I18n.get.misc.to}
              inputFormat="YYYY-MM-DD"
              value={state.to}
              onChange={(newValue: any) =>
                handleChange("to", newValue.format("YYYY-MM-DD"))
              }
              renderInput={(params: any) => (
                <VoTextField
                  {...params}
                  label={I18n.get.misc.to}
                  variant="filled"
                  fullWidth
                  required
                  size="small"
                />
              )}
            />
          </Grid>
        )}
        {filters.indexOf("groupBy") > -1 && (
          <Grid item xs>
            <VoSelectField
              SelectProps={{
                name: "groupBy",
                value: state.groupBy,
                onChange: ({ target: { name, value } }) => {
                  handleChange(name, value);
                },
                multiple: false,
                size: "small",
              }}
              availableValues={I18n.get.vocertStatistics.groupByValues.diplomas.filter(
                (v: GeneralObject) => groupBy.indexOf(v.value) > -1
              )}
              label={I18n.get.vocertStatistics.groupBy}
              fullWidth
            />
          </Grid>
        )}

        <Grid item xs sx={{ textAlign: "right" }}>
          <Button
            disableElevation
            variant="contained"
            color="primary"
            onClick={() => onChange && onChange(state)}>
            {I18n.get.actions.generate}
          </Button>
        </Grid>
      </Grid>

      {csv && (
        <DownloadCsvButton
          filename={getFilename(csv, "csv")}
          headers={csv.headers}
          data={csv.data}
        />
      )}
      {excel && (
        <DownloadExcelButton
          filename={getFilename(excel, "xlsx")}
          sheets={excel.sheets}
        />
      )}
    </Box>
  );
};

export default Header;
